import React from 'react'
import styled from 'styled-components'
import { PageHero, StripeCheckout } from '../components'
// extra imports
import { useCartContext } from '../context/cart_context'
import { Link } from 'react-router-dom'

const CheckoutPage = () => {
  let {cart} = useCartContext();
  return (<main>
         <PageHero title='checkout'></PageHero>
         <Wrapper className='page section section-center'>
          {cart.length < 1? <div className='empty'>
            <h2>Your cart is empty</h2>
            <Link to='/products' className='btn'>Fill it</Link>
          </div>: <StripeCheckout></StripeCheckout>}
         
</Wrapper>
  </main>
  )
}
const Wrapper = styled.div`
display: flex;
justify-content:center;
align-items:center;
.empty{
  text-align:center;
}

`
export default CheckoutPage
